export default {
  pagination: {},
  group: null,
  groups: [],
  groupsFilter: []
};
